const Footer = () => <footer className="page-footer">Sticky footer</footer>;

export default Footer;
